const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const makeRequest = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  const data = await response.json();
  if (!response.ok) {
    const err = new Error(data.message || data.error || `HTTP error! status: ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }
  return data;
};

/**
 * List databases on innova-production-sqlserver.
 * @returns {Promise<Array<{ name: string, status?: string, sizeMb?: string, elasticPool?: string }>>}
 */
export const listExportableDatabases = async () => {
  return await makeRequest(`${API_BASE_URL}/api/database-exports/databases`);
};

/**
 * Kick off a BACPAC export for one or more databases. Returns a session ID
 * that can be polled via getExportStatus.
 * @param {string[]} databases
 * @returns {Promise<{ sessionId: string }>}
 */
export const startExport = async (databases) => {
  return await makeRequest(`${API_BASE_URL}/api/database-exports/start`, {
    method: 'POST',
    body: JSON.stringify({ databases }),
  });
};

/**
 * Poll the status of a running export session.
 * @param {string} sessionId
 * @returns {Promise<DatabaseExportSession>}
 */
export const getExportStatus = async (sessionId) => {
  return await makeRequest(
    `${API_BASE_URL}/api/database-exports/status/${encodeURIComponent(sessionId)}`
  );
};

/**
 * Recent export sessions.
 * @param {number} count
 * @returns {Promise<DatabaseExportSession[]>}
 */
export const getExportHistory = async (count = 20) => {
  return await makeRequest(`${API_BASE_URL}/api/database-exports/history?count=${count}`);
};
